// File: SportsAboutSection.jsx
// Pure CSS + dummy images + one using uploaded screenshot
// Two side sections: About Team (left), About Coach (right with angled orange background)

import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';

export default function AboutUsCard2() {
  return (<>
    <section className="sp-wrap-ac-2">
      <div className="sp-left-ac-2">
        <h2>About Team</h2>
        <div className="sp-img card-ac-2">
                <img src="https://picsum.photos/620/400?random=5" alt="coach" />
        </div>
        <p className="sp-text-ac-2">
          Te obtinuit ut adepto satis somno. Aliisque institutoribus iter deliciae vivet vita. Nam
          exempli gratia, quotiens ego vadam ad diversorum peregrinorum in mane ut effingo ex contractus.
        </p>

        <div className="sp-arrows-ac-2">
          <button><ChevronLeft size={16}/></button>
          <button><ChevronRight size={16}/></button>
        </div>
      </div>

      <div className="sp-right-ac-2">
        <div className="sp-orange-angle"></div>
        <h2>About Coach</h2>

        <div className="sp-img card-ac-2">
          <img src="https://picsum.photos/620/400?random=4" alt="coach" />
        </div>

        <p className="sp-text-ac-2">
          Te obtinuit ut adepto satis somno. Aliisque institutoribus iter deliciae vivet vita. Nam exempli
          gratia, quotiens ego vadam ad diversorum peregrinorum in mane ut effingo ex contractus.
        </p>

        <div className="sp-name-ac-2">George F Wills</div>
      </div>
    </section>
    <style>{`
/* File: SportsAboutSection.css */

:root {
  --orange: rgba(144, 202, 249,0.51);
  --dark: #0e0e0e;
  --white: #fff;
}

.sp-wrap-ac-2 {
  display: flex;
  padding: 60px;margin-top:50px;
  gap: 40px;
  background: #fafafa;
  position: relative;
}

.sp-left-ac-2,
.sp-right-ac-2 {
  flex: 1;
  position: relative;
}

.sp-left-ac-2 h2,
.sp-right-ac-2 h2 {color: #333;
  font-size: 38px;
  font-weight: 800;
  margin-bottom: 20px;
}

.card-ac-2 img { transform:skew(5deg);
  width: 50%;
  height: auto;
  border-radius: 6px;
  display: block;
}

.sp-text-ac-2 {
  margin: 20px 0;
  color: #333;
  font-size: 15px;
  line-height: 1.6;
  max-width: 520px;
}

/* Arrows */
.sp-arrows-ac-2 {
  display: flex;
  gap: 12px;
  margin-top: 15px;
}
.sp-arrows-ac-2 button {
  background: rgba(144, 202, 249,0.51);
  border: 2px solid #000;
  padding: 11px 14px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 4px;
}

/* Right side angled orange background */
.sp-right-ac-2 { transform:skew(-10deg);
  background: var(--orange);
  padding: 40px;
  border-radius: 4px;
  color: #fff;
}

/* Name */
.sp-name-ac-2 {
  margin-top: 20px;
  font-size: 20px;color: #333;
  font-weight: 700;
}

/* Responsive */
@media (max-width: 960px) {
.card-ac-2 img { 
  width: 100%;
  
}
  .sp-wrap-ac-2 {
    flex-direction: column;
  }.sp-left-ac-2{transform:skew(-5deg);width:130%;left:-15%;

}
    .sp-right-ac-2 {transform:skew(-5deg);width:120%;left:-20%;padding-right:80px}
}`}</style>
    </>
  );
}
